module.exports = __webpack_public_path__ + "img/sl.014ac44a.svg";